var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "65.443px",
    height: "72.5px",
    viewBox: "0 0 65.443 72.5",
    enableBackground: "new 0 0 65.443 72.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STUDIO"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -85.443,
    y: 73.75,
    fill: "none",
    width: 65.442,
    height: 13
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -81.3235 84.6299)",
    display: "none",
    fill: "#FF715A",
    enableBackground: "new    ",
    fontFamily: "'HeroWorship'",
    fontSize: 17
  }, "STUDIO"), /*#__PURE__*/React.createElement("rect", {
    x: -85.443,
    y: 77.75,
    fill: "none",
    width: 65.442,
    height: 9
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -76.7737 85.3564)",
    display: "none",
    fill: "#FF715A",
    enableBackground: "new    ",
    fontFamily: "'TeknoItalic'",
    fontSize: 15,
    letterSpacing: 3
  }, "STUDIO"), /*#__PURE__*/React.createElement("rect", {
    x: -85.443,
    y: 73.75,
    fill: "none",
    width: 65.442,
    height: 13
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -78.3567 84.0039)",
    display: "none",
    fill: "#FF715A",
    enableBackground: "new    ",
    fontFamily: "'Hindsight2020'",
    fontSize: 15
  }, "STUDIO"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "S",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35.604,
    y: 64.655,
    transform: "matrix(0.4369 0.8995 -0.8995 0.4369 47.4248 61.0375)",
    width: 21.132,
    height: 7.484
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35.344,
    y: 74.242,
    transform: "matrix(0.437 0.8995 -0.8995 0.437 52.7693 71.6666)",
    width: 8.964,
    height: 7.486
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.641,82.896l15.217-7.393c3.134,6.448-4.167,15.741-9.826,18.49L-32.641,82.896z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.615,53.521l-15.218,7.393c-3.134-6.45,4.167-15.741,9.827-18.491L-17.615,53.521z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23.675,
    y: 55.091,
    transform: "matrix(-0.4369 -0.8995 0.8995 -0.4369 -80.4996 67.2747)",
    width: 8.965,
    height: 7.486
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.886,
    y: 64.375,
    width: 7.485,
    height: 24.215
  }), /*#__PURE__*/React.createElement("rect", {
    x: -28.319,
    y: 76.188,
    width: 7.484,
    height: 12.401
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.319,87.746H-11.4c0,7.171-10.626,12.338-16.919,12.338V87.746z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.452,
    y: 63.922,
    width: 7.485,
    height: 12.401
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.967,64.766h-16.919c0-7.172,10.626-12.339,16.919-12.339V64.766z"
  })), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FF715A",
    d: "M5.969,21.374l2.583-2.301l2.33,5.303l5.359-4.957l-0.043-0.03 C16.175,8.688,7.495,0.018-3.214,0.018c-0.694,0-1.384,0.041-2.062,0.112h-25.667l22.467,51.185l-2.601,2.246l-2.732-6.071 l-5.426,5.02h-0.092C-19.326,63.275-10.597,72,0.166,72c0.236,0,0.463-0.025,0.695-0.037L0.879,72h27.579L5.969,21.374z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FF715A",
    d: "M-20,36.013"
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FF715A",
    points: "5.593,26.561 13.361,32.515 23.395,21.525 -3.229,0 -26.007,17.678  -11.781,45.452 -19.71,39.375 -30.365,51.003 -3.23,72 19.547,54.322  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "65.443,41.729 47.094,0 32.722,13.306 18.35,0 0,41.729 18.18,58.646 18.18,36.932 23,41.12 23,62.834  32.557,72.025 42.5,62.667 42.5,41.042 47.142,36.932 47.142,58.59  "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.8b0aee7d41f5cd9622548437ecdc92c5.svg";
export { ForwardRef as ReactComponent };